module.exports = "https://cdn.realtymogul.com/static/media/icon_collapse_wht.d2e9644a.svg";